import { Injectable } from '@angular/core';

@Injectable()
export class NecLocalStorageService {
  /**
   * ç»ä¸çlocalStorageåç¼
   */
  prefix = 'kyEdu-';

  /**
   * æ ¹æ®keyè·åå­å¨çå¼
   */
  get(key: string): any {
    return JSON.parse(localStorage.getItem(this.prefix + key));
  }

  /**
   * å­å¨
   */
  set(key: string, value: any): void {
    localStorage.setItem(this.prefix + key, JSON.stringify(value));
  }

  /**
   * å é¤å·²ç»å­å¨çå¼
   */
  del(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }
}
